import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
    Grid,
    Stack,
    Button,
    TextField,
    Typography,
    IconButton,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons  
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_OFFICE, UPDATE_OFFICE } from "../../Schema/Office";

export default function OfficeForm({ open, handleClose, setRefetch, dialogTitle, editData }) {
    // Change Language
    const { setAlert } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    //====================== Creatae Office =============================
    const [createOffice] = useMutation(CREATE_OFFICE, {
        onCompleted: ({ createOffice }) => {
            setLoading(false);
            if (createOffice?.status) {
                setAlert(true, "success", createOffice?.message);
                handleClose();
                resetForm();
                setRefetch();
            } else {
                setAlert(true, "error", createOffice?.message);
            }
        },
        onError: (error) => {
            setLoading(false);
            setAlert(true, "error", error?.message);
        },
    });
    //====================== Update Office =============================
    const [updateOffice] = useMutation(UPDATE_OFFICE, {
        onCompleted: ({ updateOffice }) => {
            setLoading(false);
            if (updateOffice?.status) {
                setAlert(true, "success", updateOffice?.message);
                handleClose();
                setRefetch();
            } else {
                setAlert(true, "error", updateOffice?.message);
            }
        },
        onError: (error) => {
            setLoading(false);
            setAlert(true, "error", error?.message);
        },
    });

    //fromik
    const CheckValidation = Yup.object().shape({
        officeEnName: Yup.string().required("require!"),
        officeKhName: Yup.string().required("require!"),
        remark: Yup.string(),

    });

    const formik = useFormik({
        initialValues: {
            officeEnName: "",
            officeKhName: "",
            remark: ""
        },

        validationSchema: CheckValidation,
        onSubmit: async (values) => {
            console.log("...values,", values)
            setLoading(true);
            if (dialogTitle === "Create") {
                createOffice({
                    variables: {
                        input: {
                            ...values,
                        },
                    },
                });
            } else {

                updateOffice({
                    variables: {
                        id: editData?._id,
                        input: {
                            ...values,
                        },
                    },
                });

            }
        },
    });

    const {
        errors,
        touched,
        handleSubmit,
        getFieldProps,
        setFieldValue,
        values,
        resetForm,
    } = formik;


    useEffect(() => {
        if (editData) {
            setFieldValue("officeKhName", editData?.officeKhName)
            setFieldValue("officeEnName", editData?.officeEnName)
            setFieldValue("remark", editData?.remark)
        }
    }, [editData])
    return (
        <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
            <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
                <Stack direction="row" justifyContent="space-between">
                    <Stack direction="column" justifyContent="center">
                        <Typography className="dialog-title">
                            {dialogTitle === "Create" ? "បង្កើតការិយាល័យ" : "កែប្រែការិយាល័យ"}
                        </Typography>
                    </Stack>
                    <Stack direction="column" justifyContent="center">
                        <IconButton onClick={handleClose}>
                            <BiMinusCircle className="close-icon" />
                        </IconButton>
                    </Stack>
                </Stack>
            </DialogTitle>

            <DialogContent dividers>
                <FormikProvider value={formik}>
                    <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                        <Grid container rowSpacing={2} columnSpacing={3}>
                            <Grid item xs={6} sm={12}>
                                <Typography className="field-title">ឈ្មោះការិយាល័យជាខ្មែរ</Typography>
                                <TextField
                                    className="text-field"
                                    fullWidth
                                    size="small"
                                    placeholder="ឈ្មោះការិយាល័យ"
                                    {...getFieldProps("officeKhName")}
                                    error={Boolean(touched.officeKhName && errors.officeKhName)}
                                    helperText={touched.officeKhName && errors.officeKhName}
                                />
                            </Grid>
                            <Grid item xs={6} sm={12}>
                                <Typography className="field-title">ឈ្មោះការិយាល័យជាអង់គ្លេស</Typography>
                                <TextField
                                    className="text-field"
                                    fullWidth
                                    size="small"
                                    placeholder="ឈ្មោះការិយាល័យ"
                                    {...getFieldProps("officeEnName")}
                                    error={Boolean(touched.officeEnName && errors.officeEnName)}
                                    helperText={touched.officeEnName && errors.officeEnName}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography className="field-title">Remark</Typography>
                                <TextField
                                    className="text-field"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    size="small"
                                    placeholder="remark"
                                    {...getFieldProps("remark")}
                                    error={Boolean(touched.remark && errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {loading ? (
                                    <Button className="btn-create" fullWidth>
                                        កំពុងដំណើរការ...
                                    </Button>
                                ) : (
                                    <Button
                                        className="btn-create"
                                        fullWidth
                                        onClick={handleSubmit}
                                    >
                                        {dialogTitle === "Create" ? "បង្កើត" : "កែប្រែ"}
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Form>
                </FormikProvider>
            </DialogContent>
        </Dialog>
    );
}
